class Account {
  constructor(id, typoCategory, typoType, phone, establishmentArea) {
    this._id = id;
    this._typo_category = typoCategory;
    this._typo_type = typoType;
    this._phone = phone;
    this._establishmentArea = establishmentArea;
  }

  isValid() {
    for (var item in this) {
      if (this[item] === null || this[item] === '' || this[item] === undefined) {
        return false;
      }
    }
    return true;
  }

  // getters
  getId() {
    return this._id;
  }

  getTypoCategory() {
    return this._typo_category;
  }

  getTypoType() {
    return this._typo_type;
  }

  getPhone() {
    return this._phone;
  }

  getEstablishmentArea() {
    return this._establishmentArea;
  }

  // setters
  setId(newId) {
    this._id = newId;
    return this;
  }

  setTypoCategory(newTypoCategory) {
    this._typo_category = newTypoCategory;
    return this;
  }

  setTypoType(newTypoType) {
    this._typo_type = newTypoType;
    return this;
  }

  setPhone(newPhone) {
    this._phone = newPhone;
    return this;
  }

  setEstablishmentArea(newEstablishmentArea) {
    this._establishmentArea = newEstablishmentArea;
    return this;
  }

  serialize() {
    return { ...this, '@type': 'Account' };
  }

  clone() {
    return new Account(
      this._id,
      this._typo_category,
      this._typo_type,
      this._phone,
      this._establishmentArea,
    );
  }

  static deserialize(raw) {
    return new Account(
      raw._id,
      raw._typo_category,
      raw._typo_type,
      raw._phone,
      raw._establishmentArea,
    );
  }
}

export default Account;



// WEBPACK FOOTER //
// ./src/models/SFModels/Account.js